import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Box from '@mui/material/Box';

import CloseIcon from '@mui/icons-material/Close';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import BackspaceIcon from '@mui/icons-material/Backspace';
import RefreshIcon from '@mui/icons-material/Refresh';

import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';

import Bs4Dialog from '../Bs4Components/Bs4Dialog'
import Bs4Kartoteka from '../Bs4Kartoteka';
import Bs4MainDispatch from '../Bs4MainDispatch';
import { SmallScreenContext } from '../Bs4Theme/Bs4UxTemplates';
import Bs4I18N from '../Bs4I18N';
import Bs4FormElement from '../Bs4Form/Bs4FormElement';

export default function Bs4Criteria(props) {
  const clearAllTT = Bs4I18N.getTT('Wyczyść wszystkie', 'Clear all', Bs4Criteria.name);
  const showTT = Bs4I18N.getTT('Pokaż', 'Show', Bs4Criteria.name);
  const showCloseTT = Bs4I18N.getTT('Pokaż, zamknij', 'Show, close', Bs4Criteria.name);
    
  const [open, setOpen] = React.useState(false);
  const [refFocus, setRefFocus] = React.useState(null);
  const refHeader = React.useRef(null);

  const smallScreen = React.useContext(SmallScreenContext);
  
  const bs4Form = React.useMemo(() => {
    const bs4Kartoteka = Bs4Kartoteka.get(props.bs4KartotekaId);
    const bs4Option = bs4Kartoteka.getBs4Option(props.optionId);
    if (bs4Option.bs4Form) return bs4Option.bs4Form;
    return {
      ViewComponent: () => <div> Bs4Criteria error: bs4KartotekaId:{props.bs4KartotekaId} optionId:{props.optionId} </div>,
    };
  }, []);

  const reload = React.useCallback(() => {
    const bs4Kartoteka = Bs4Kartoteka.get(props.bs4KartotekaId);
    const bs4Option = bs4Kartoteka.getBs4Option(props.optionId);
    bs4Option?.bs4Grid?.reload();
  }, [props.bs4KartotekaId, props.optionId]);

  const setOpenCriteria = React.useCallback((newOpen) => {
    setOpen(newOpen);   
    bs4Form.isOpenCriteria = newOpen;         
    if (!newOpen) {
      bs4Form.closeBs4Form();
      bs4Form.showTooltip?.closeTooltip();        
      bs4Form.showTooltip?.setShowTooltip(null);        
    }
  }, [setOpen, bs4Form]);

  const handleOpen = () => {
    bs4Form.saveState();    
    setOpenCriteria(true);
  };

  const handleClear = () => {
    bs4Form.clear();
  };

  const handleShow = () => {
    setRefFocus(null);
    bs4Form.isOpenCriteria = false;
    bs4Form.saveState();
    bs4Form.restoreState();
    bs4Form.isOpenCriteria = true;
    reload();    
  };

  const handleShowClose = React.useCallback((event) => {
    setRefFocus(null);
    setOpenCriteria(false);
    bs4Form.saveState();
    bs4Form.restoreState();
    reload();
  }, [bs4Form, setRefFocus, setOpenCriteria, reload]);

  const handleClose = React.useCallback((event) => {        
    setRefFocus(null);
    setOpenCriteria(false);    
    console.log('...Bs4Criteria...Close...')
    bs4Form.restoreState();    
  }, [bs4Form, setRefFocus, setOpenCriteria]);

  const handleKeyDoun = (event) => {
    if (event.key === 'Enter' && !bs4Form?.currentField) {
      console.log('...Bs4Criteria...KeyDoun...', event.key, bs4Form?.currentField)
      handleShowClose(event)
    }
  }

  const handleGear = () => {
    Bs4MainDispatch.commandParser('Bs4OpenCard', {targetObject: props.optionId, targetOption: 2000234}, props.bs4KartotekaId);
  };

  React.useEffect(() => {
    if (refFocus?.current) refFocus.current.focus();
  }, [refFocus?.current])

  React.useEffect(() => {
    if (bs4Form) {
      bs4Form.openCriteria = handleOpen;
      bs4Form.closeCriteria = (event) => {handleShowClose(event)};        
      [...bs4Form?.getFields()].forEach(field => {
        field.summaryFieldClicked = (refFocus) => {
          handleOpen();
          setRefFocus(refFocus);
        }                    
      });
    }
  }, [bs4Form, handleShowClose, handleOpen, handleClose])
    
  if (bs4Form.getFields()?.length < 1) return null;
  
  return (
    <Box>
      <IconButton disabled={open} onClick={handleOpen}>
        <ManageSearchIcon/>
      </IconButton>      
      <Bs4Dialog       
        // fullScreen
        open={open} 
        onClose={handleClose} 
        onKeyDown={handleKeyDoun}
        bs4KartotekaId={props.bs4KartotekaId} 
        refHeader={refHeader} 
        maxWidth={smallScreen ? 'xl' : 'md'}
        sygn='criteria'
      >
        <DialogTitle ref={refHeader} sx={{touchAction: 'none'}}>
          <Stack ref={refHeader} direction='row' justifyContent="space-between" sx={{cursor:'move'}}>
            <ManageSearchIcon/>
            <Stack direction='row' justifyContent="space-between" spacing={2}>
              {bs4Form.bs4ConstructorMode.enabled ? 
                <IconButton edge='end' onClick={handleGear}><i className="fa-solid fa-gear"/></IconButton>
              : null}
              <IconButton edge='end' onClick={handleClose}><CloseIcon /></IconButton>
            </Stack>
          </Stack>            
        </DialogTitle>
        <DialogContent>
          <bs4Form.ViewComponent uxKartoteka={props.uxKartoteka}/>
        </DialogContent>       
        <DialogActions>
          <Stack direction="row" justifyContent="flex-end" alignItems="center" spacing={1}>
            <Button onClick={handleClear} startIcon={<BackspaceIcon/>}>{clearAllTT}</Button>
            <div style={{flex: '1 0 0'}} />
            {smallScreen ? null : <Button onClick={handleShow} startIcon={<RefreshIcon/>}>{showTT}</Button>}
            <Button onClick={handleShowClose} startIcon={<RefreshIcon/>}>{showCloseTT}</Button>
          </Stack>            
        </DialogActions>   
      </Bs4Dialog>      
    </Box>
  );
}
